import { useNavigate, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useDashboardStats from "../../hooks/useDashboardStats";
import useLinkedUploadAgencies from "../../hooks/useLinkedUploadAgencies";
import DashboardStatsBar from "../dashboard/DashboardStatsBar";
import { withReturnPath } from "../../utils/navReturn";
import "../../styles/dashboard.css";

function formatCount(n) {
  const num = Number(n) || 0;
  return num.toLocaleString("en-IN");
}

export default function FindVehiclesStatsPanel({
  className = "fv-stats-panel home-field-stats",
  returnPathFallback = "/find-vehicles",
}) {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isRepoAdmin = auth?.user?.role === "REPO_ADMIN";
  const { stats, loading, error } = useDashboardStats();
  const {
    companyTotalRecords,
    companyOwnRecords,
    allBanksNbfcsRecords,
    loading: sourcesLoading,
    error: sourcesError,
    reload: reloadSources,
  } = useLinkedUploadAgencies();

  const handleStatClick = (key) => {
    const returnTo =
      `${location.pathname}${location.search}` || returnPathFallback;

    if (key === "pending") {
      navigate(withReturnPath("/confirmation?status=PENDING", returnTo));
      return;
    }

    if (key === "confirmations") {
      navigate(withReturnPath("/confirmation?status=CONFIRMED", returnTo));
      return;
    }

    if (key === "inventory") {
      navigate(withReturnPath("/seized-vehicles", returnTo));
      return;
    }

    if (key === "records") {
      if (isRepoAdmin) {
        navigate(withReturnPath("/bank-details", returnTo));
      } else {
        navigate("/find-vehicles");
      }
    }
  };

  const handleRecordStatClick = (key) => {
    const returnTo =
      `${location.pathname}${location.search}` || returnPathFallback;

    if (key === "agency") {
      if (isRepoAdmin) {
        navigate(withReturnPath("/bank-details", returnTo));
        return;
      }
      navigate("/find-vehicles");
      return;
    }

    if (key === "banks") {
      if (isRepoAdmin) {
        navigate(withReturnPath("/bank-records", returnTo));
        return;
      }
      navigate("/find-vehicles");
      return;
    }

    navigate(isRepoAdmin ? withReturnPath("/find-vehicles", returnTo) : "/find-vehicles");
  };

  const recordItems = [
    {
      key: "agency",
      label: "Agency Upload Repo List Details",
      icon: "📁",
      desc: "Agency uploaded repo records",
      value: formatCount(companyOwnRecords),
    },
    {
      key: "banks",
      label: "All Banks / NBFCs Uploaded Records",
      icon: "🏦",
      desc: "Records uploaded by linked banks",
      value: formatCount(allBanksNbfcsRecords),
    },
    {
      key: "allRecords",
      label: "All Records",
      icon: "📊",
      desc: "Agency plus banks/NBFC records",
      value: formatCount(companyTotalRecords),
    },
  ];

  const renderUploadSourceCards = () => {
    if (sourcesError) {
      return (
        <div className="fv-agency-upload-empty fv-agency-upload-empty--error">
          <p className="error-text">{sourcesError}</p>
          <button type="button" className="secondary-page-btn" onClick={reloadSources}>
            Retry
          </button>
        </div>
      );
    }

    return (
      <DashboardStatsBar
        className="home-hero__stats"
        variant="field"
        items={recordItems}
        loading={sourcesLoading}
        activeKey=""
        onStatClick={handleRecordStatClick}
      />
    );
  };

  return (
    <section
      className={className}
      aria-label="Upload and confirmation stats"
    >
      {error ? <p className="error-text fv-stats-error">{error}</p> : null}

      <DashboardStatsBar
        className="home-hero__stats"
        variant="field"
        stats={stats}
        loading={loading}
        activeKey=""
        onStatClick={handleStatClick}
      />

      {renderUploadSourceCards()}
    </section>
  );
}
